import { render, staticRenderFns } from "./GuestAdvert.vue?vue&type=template&id=8f828b78&scoped=true&"
import script from "./GuestAdvert.vue?vue&type=script&lang=js&"
export * from "./GuestAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f828b78",
  null
  
)

export default component.exports